import * as React from 'react';

import { useLearnerPlanStoreContext } from 'bundles/degree-home/components/v3-dpm/context/LearnerPlanStoreContext';
import type { UseCurriculum_SegmentCourseFragment as SegmentCourse } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';

export type EnrollmentDiaglogEventingContextType = {
  termName: string | undefined;
  courseName: string | undefined;
  courseCreditValue: number | undefined;
  isCourseElective: boolean | undefined;
};

const EnrollmentDiaglogEventingContext = React.createContext<EnrollmentDiaglogEventingContextType>({
  termName: undefined,
  courseName: undefined,
  courseCreditValue: undefined,
  isCourseElective: undefined,
});

// no error is thrown if the context is undefined, the consumer will handle such case
export const useEnrollmentDiaglogEventingContext = () => React.useContext(EnrollmentDiaglogEventingContext);

type Props = {
  segmentCourse: SegmentCourse;
  termName?: string;
};

const EnrollmentDiaglogEventingContextProvider = ({
  termName,
  segmentCourse,
  children,
}: React.PropsWithChildren<Props>) => {
  const { requirementTypeData } = useLearnerPlanStoreContext();
  const isElective = requirementTypeData?.[segmentCourse.id]?.isElective ?? undefined;
  const courseName = segmentCourse.course.courseName;
  const creditValue = segmentCourse.creditValue;
  return (
    <EnrollmentDiaglogEventingContext.Provider
      value={{ termName, courseName, courseCreditValue: creditValue, isCourseElective: isElective }}
    >
      {children}
    </EnrollmentDiaglogEventingContext.Provider>
  );
};

export default EnrollmentDiaglogEventingContextProvider;
